import { gql } from '@apollo/client/core';
import LocationService from '@/services/LocationService';
import { executeQuery } from '@/components/commons/utils.js';

const MESSAGING_QUERY = gql`
  query messaging($zip: String) {
    messaging(zip: $zip){
      legacyShippingDiscountDetails
      legacyShippingDiscountMessage
      baselineShippingCostDiscounted
      shippingDiscountThreshold
      baselineShippingCost
      message{
        id
        countryId
        text
        etaText
        active
        name
        createdDate
      }
    }
    commonData{
      livechatOverlayEnabled
      ugcPixleeEnabled
      blackFridayContactEnabled
      csPhoneWeekdaysHoursStart
      csPhoneWeekdaysHoursEnd
      csPhoneWeekendHoursStart
      csPhoneWeekendHoursEnd
      csChatWeekdaysHoursStart
      csChatWeekdaysHoursEnd
      csChatWeekendHoursStart
      csChatWeekendHoursEnd
      csChatOverlayWeekdaysHoursStart
      csChatOverlayWeekdaysHoursEnd
      csChatOverlayWeekendHoursStart
      csChatOverlayWeekendHoursEnd
    }
  }
`;

export default class MessagingService {
  static async fetchMessaging(zip) {
    const zipcode = zip || LocationService.getPreferredLocation().zipcode;

    try {
      const result = await executeQuery(MESSAGING_QUERY, {
        zip: zipcode,
      });

      return{
        messaging: result.messaging,
        common: result.commonData
      }
    } catch (error) {
      console.error(error);
      return {
        error,
      };
    }
  }
}
